import { FC } from 'react';

import styles from 'pages/MultiCreationAuctionPage/MultiCreationAuctionPage.module.less';

import { Header } from 'components/Header/Header';
import { MultiCreationAuction } from 'components/MultiCreationAuction/MultiCreationAuction';

export const MultiCreationAuctionPage: FC = () => {
    return (
        <div className={styles.wrapper}>
            <Header />
            <MultiCreationAuction />
        </div>
    );
};
